<template>
  <div class="scenario">
    <p class="tips">
      <i class="el-icon-info"></i>
      <span>只有团队队长才能进行脚本的管理操作</span>
    </p>
    <el-table :data="list" stripe class="list">
      <el-table-column prop="episode" label="集数" width="80" align="center">
      </el-table-column>
      <el-table-column prop="title" label="文案名称"> </el-table-column>
      <el-table-column fixed="right" label="操作" width="150" align="center">
        <template slot-scope="{ row }">
          <el-button
            size="mini"
            type="text"
            @click="handleManage(row.waId, row.title)"
            >{{ isCaptain ? "脚本创作" : "查看脚本" }}</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      title="脚本创作工具"
      :visible.sync="show"
      width="80%"
      center
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <div style="line-height: 32px">
        <p style="float: left">
          所属文案名称: <b>{{ waName }}</b>
        </p>
        <el-button
          type="primary"
          size="small"
          style="float: right; margin-bottom: 10px"
          @click="handleAdd"
          :disabled="!isCaptain"
          >新增脚本</el-button
        >
      </div>
      <el-table :data="sList" stripe class="list">
        <el-table-column type="index" label="序号" width="60" align="center">
          <template slot-scope="scope">
            <span v-if="scope.$index == 0" style="color: #409eff">范例</span>
            <span v-else>{{ scope.$index }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="jb" label="景别" width="90" align="center">
          <template slot-scope="scope">
            <span v-if="scope.$index == 0" style="color: #409eff">{{
              scope.row.jb
            }}</span>
            <div v-else>
              <el-select
                v-model="scope.row.jb"
                placeholder="请选择"
                size="mini"
                :disabled="!isCaptain"
              >
                <el-option
                  v-for="item in jbList"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="jd" label="角度" width="90" align="center">
          <template slot-scope="scope">
            <span v-if="scope.$index == 0" style="color: #409eff">{{
              scope.row.jd
            }}</span>
            <div v-else>
              <el-select
                v-model="scope.row.jd"
                placeholder="请选择"
                size="mini"
                :disabled="!isCaptain"
              >
                <el-option
                  v-for="item in jdList"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="jtsc" label="镜头时长" width="80" align="center">
          <template slot-scope="scope">
            <span v-if="scope.$index == 0" style="color: #409eff">{{
              scope.row.jtsc
            }}</span>
            <div v-else>
              <el-input
                v-model="scope.row.jtsc"
                placeholder="请输入时长"
                size="mini"
                :readonly="!isCaptain"
              ></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="pshm" label="拍摄画面" align="center">
          <template slot-scope="scope">
            <span v-if="scope.$index == 0" style="color: #409eff">{{
              scope.row.pshm
            }}</span>
            <div v-else>
              <el-input
                v-model="scope.row.pshm"
                type="textarea"
                resize="none"
                placeholder="请输入拍摄画面"
                size="small"
                :autosize="{ minRows: 1, maxRows: 5}"
                :readonly="!isCaptain"
              ></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="sy" label="声音" align="center">
          <template slot-scope="scope">
            <span v-if="scope.$index == 0" style="color: #409eff">{{
              scope.row.sy
            }}</span>
            <div v-else>
              <el-input
                v-model="scope.row.sy"
                placeholder="配合画面所需的声音"
                size="mini"
                :readonly="!isCaptain"
              ></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="py" label="配乐" width="100" align="center">
          <template slot-scope="scope">
            <span v-if="scope.$index == 0" style="color: #409eff">{{
              scope.row.py
            }}</span>
            <div v-else>
              <el-input
                v-model="scope.row.py"
                placeholder="配合画面所需的背景音乐"
                size="mini"
                :readonly="!isCaptain"
              ></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="psdd" label="拍摄地点" align="center">
          <template slot-scope="scope">
            <span v-if="scope.$index == 0" style="color: #409eff">{{
              scope.row.psdd
            }}</span>
            <div v-else>
              <el-input
                v-model="scope.row.psdd"
                placeholder="拍摄画面地点变化"
                size="mini"
                :readonly="!isCaptain"
              ></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="dj" label="道具" width="100" align="center">
          <template slot-scope="scope">
            <span v-if="scope.$index == 0" style="color: #409eff">{{
              scope.row.dj
            }}</span>
            <div v-else>
              <el-input
                v-model="scope.row.dj"
                placeholder="画面配套的道具"
                size="mini"
                :readonly="!isCaptain"
              ></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="60" align="center">
          <template slot-scope="scope">
            <el-button
              v-if="isCaptain && scope.$index > 0"
              size="mini"
              type="text"
              @click="handledel(scope.$index)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleClose">取 消</el-button>
        <el-button
          v-if="isCaptain"
          type="primary"
          size="small"
          @click="handleSubmit"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  myCopywriting,
  scenarioList,
  save,
} from "@/api/projectPractice/scenario";

export default {
  data() {
    return {
      isCaptain: false,
      list: [],
      sList: [],
      waName: "",
      show: false,
      example: {
        jb: "中景",
        jd: "侧面",
        jtsc: "2S",
        pshm: "男主坐在办工桌前，敲打键盘，双眼盯着显示器，桌上凌乱的放着一堆文件",
        sy: "键盘敲击声",
        py: "无",
        psdd: "办公室到夜景",
        dj: "电脑",
      },
      jbList: ["远景", "全景", "中景", "近景", "特写"],
      jdList: ["正面", "侧面", "背面", "斜侧面"],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.$loading.show();
      myCopywriting({ classId: this.$route.query.id }).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.list = res.data.list;
          this.isCaptain = res.data.isCaptain;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 脚本列表
    handleManage(waId, waName) {
      this.waName = waName;
      this.waId = waId;
      this.$loading.show();
      scenarioList(waId).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.sList = res.data;
          this.sList.unshift(this.example);
          this.show = true;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 添加
    handleAdd() {
      this.sList.push({
        jb: "",
        jd: "",
        jtsc: "",
        pshm: "",
        sy: "",
        py: "",
        psdd: "",
        dj: "",
      });
    },
    // 删除
    handledel(idx) {
      this.$confirm("确定要删除吗?", {
        type: "warning",
      })
        .then(() => {
          this.sList.splice(idx, 1);
        })
        .catch(() => {});
    },
    // 提交
    handleSubmit() {
      this.$confirm("确定要提交吗?", {
        type: "warning",
      })
        .then(() => {
          let list = [...this.sList];
          list.shift();

          this.$loading.show();
          save({ waId: this.waId, list }).then((res) => {
            this.$loading.hide();
            if (res.code == 0) {
              this.show = false;
              this.$message.success("保存成功");
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
    handleClose() {
      this.$confirm("关闭后未保存的编辑内容将丢失,确定要关闭吗?", {
        type: "warning",
      })
        .then(() => {
          this.show = false;
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
.scenario {
  .tips {
    margin-bottom: 10px;
    text-align: left;
    color: #f56c6c;
    i {
      margin-right: 5px;
    }
  }
  ::v-deep .list {
    .is-leaf {
      color: #333;
      background-color: #f5f5f5;
    }
    .el-textarea__inner {
      font-family: inherit;
    }
  }
}
</style>